var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-center mt-5"},[_vm._v("Imagenes")]),_c('imagen',{attrs:{"items":_vm.Items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }